// DS: i4.37
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const Sale = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3337 2.66676V8.00008L12.267 8.00008V9.06675L11.2003 9.06675V10.1334L10.1337 10.1334V11.2001L9.06699 11.2001V12.2667L8.00033 12.2667V13.3334H6.93366L6.93366 12.2667H5.86699L5.86699 11.2001H4.80033L4.80033 10.1334H3.73366L3.73366 9.06675H2.66699V8.00008H3.73366L3.73366 6.93341H4.80033L4.80033 5.86675H5.86699L5.86699 4.80008H6.93366L6.93366 3.73341H8.00033L8.00033 2.66675L13.3337 2.66676ZM10.1337 4.26675L11.7337 4.26675V5.86675L10.1337 5.86675L10.1337 4.26675Z"
    })));
Sale.displayName = 'Sale';
export default Sale;
